import React, { Component } from 'react';
import moment from 'moment';
import networkList from '../../../constants/networkList';
let dollarIndianLocale = Intl.NumberFormat('en-IN');
const { base_url, homepage } = networkList;
class Cash_preview extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {},
            patient_validate: false,
            currentDateTime: new Date().toLocaleString()
        }
    }
    componentDidMount() {        
        let { cash_preview_data, patient_validate } = this.props
        this.setState({ 'data': cash_preview_data,  patient_validate: patient_validate, currentDateTime: new Date().toLocaleString()})
        console.log('cash_preview_data',cash_preview_data)
    }

    roundAmount(amount) {

        if (amount < 50) {
          return Math.floor(amount / 100) * 100;
        } else {
          return Math.round(amount / 100) * 100;
        }
      }
    // roundAmount(amount) {
    //     if (amount % 100 === 50) {
    //       return amount; // No rounding for values ending in 150
    //     } else if (amount % 100 <= 50) {
    //       return Math.floor(amount / 100) * 100;
    //     } else {
    //       return Math.ceil(amount / 100) * 100;
    //     }
    //   }
      
          
    render() {
        let { data, patient_validate, created_date } = this.state
        let user_data
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        // const HeaderAmount = data?.reduce((sum, item) => sum + (item.header_amount || 0), 0);
        // console.log("Total Amount:", HeaderAmount);
        const totalAmount = this.roundAmount(data.total_Estimate_amount);

// Calculate -10% and +10%
const lowerBound = data["estimate_type"] === 1 ? totalAmount : (totalAmount * 0.9); // 90% of total amount
const upperBound = totalAmount * 1.1; // 110% of total amount

// Format the values
const formattedLowerBound = dollarIndianLocale.format(this.roundAmount(lowerBound));
const formattedUpperBound = dollarIndianLocale.format(this.roundAmount(upperBound));

{/* Calculate Subtotal */}
// const subtotal = this.roundAmount(
//     (data['package_amt'] || 0) + 
//     (data['additional_packages'] || []).reduce((acc, feild) => acc + (feild.amount || 0), 0)
// );

const subtotal = this.roundAmount(
    (Number(data['package_amt']) || 0) + 
    (data['additional_packages'] || []).reduce((acc, feild) => acc + (Number(feild.amount) || 0), 0)
);


// Step 1: Filter and calculate displayedRows
const displayedRows = [
    { id: 1, label: "Room Charges", key: "room_charges" },
    { id: 2, label: "Investigation charges", key: "room_investigation_charges" },
    { id: 3, label: "Service charges", key: "icu_investigation_charges" },
    { id: 4, label: "Pharmacy charges", key: "ip_pharmacy_charges" },
    { id: 5, label: "OT/ Cath Lab charges", key: "ot_cath_pharmacy" },
    { id: 6, label: "Procedure Charges", key: "procedure_charges" },
    { id: 7, label: "Other miscellaneous charges", key: "blood_bank_charges" },
    { id: 8, label: "Consultation fees", key: "consultation_charges" },
    { id: 9, label: "Professional fees", key: "surgical_charges", key2: "medical_charges" },
].filter(({ key, key2 }) => {
    if (!data["header_amount"]) return false;

    const amount = key2
        ? (data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0)
        : (data["header_amount"][key] || 0);

    console.log("AMt", amount); // Debugging

    return amount > 0;
});

// Step 2: Compute subtotal by summing all valid amounts
const Subtotal = displayedRows.reduce((sum, { key, key2 }) => {
    const amount = key2
        ? (data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0)
        : (data["header_amount"][key] || 0);

    return sum + amount;
}, 0);

console.log("Subtotal:", Subtotal); // Debugging to check the final sum
        return (<div id='previewcash'>
            {data.rn_payer_response === '32' ?
                (
                    <>
                    <React.Fragment>
                        <div className="fc-patient-copy">
                            <div className="p-4 bg-white" id="myH1">
                                <div className="clearfix">
                                    <img src={`${homepage}/assets/images/units-logo/${user_data["unitid"]&&user_data["unitid"]}.png`} alt="Kims" className="float-left"></img>
                                    <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03-testing</p>
                                </div>
        
                                <div>
                                    <h1 className="text-p-bold text-center text-uppercase py-4">Financial counselling</h1>
                                </div>
                                <div className="row m-0 pb-3 border">
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Counselling</span>
                                            <span className="w-100">: {moment(data['counselling_date']).format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>
                                    {data['counselling_type_name'] &&
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Counselling type</span>
                                            <span className="w-100">: {data['counselling_type_name']}</span>
                                        </div>
                                    </div>
                                    }{data['umr_no']&&
                                    <div className="col-4 ">
                                    <div className="d-inline-flex">
                                        <span className="w-label">UMR number</span>
                                        <span className="w-100">: {data['umr_no']}</span>
                                    </div>
                                </div>
                                    }
                                    {data['ip_no']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">IP number</span>
                                            <span className="w-100">: {data['ip_no']}</span>
                                        </div>
                                    </div>
                                  }
                                  {data['covid_status']&&
                                  <div className="col-4 ">
                                    <div className="d-inline-flex">
                                        <span className="w-label">Covid Status</span>
                                        <span className="w-100">: {data['covid_status'] ?data['covid_status']:''}</span>
                                    </div>
                                </div>
                                  }
                                    {data['patient_name']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Name</span>
                                            <span className="w-100">: {data['patient_name']}</span>
                                        </div>
                                        </div>
                                    }
                                   {
                                       data['phone_no']&&
                                       <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Phone No.</span>
                                            <span className="w-100">: {data['phone_no']}</span>
                                        </div>
                                    </div>
                                   }
                                    {data['age']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Age</span>
                                            <span className="w-100">: {data['age']}</span>
                                        </div>
                                    </div>
                                    }
                                    {data['doctor_name']&&
                                     <div className="col-4 ">
                                     <div className="d-inline-flex">
                                         <span className="w-label">Doctor Name</span>
                                         <span className="w-100">: {data['doctor_name']}</span>
                                     </div>
                                 </div>   
                                    }
                                    {data['speciality_name']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Specialty</span>
                                            <span className="w-100">: {data['speciality_name']}</span>
                                        </div>
                                    </div>
                                    }
                                    {data['care_management_name']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Care Management</span>
                                            <span className="w-100">: {data['care_management_name']}</span>
                                        </div>
                                    </div>
                                    }
                                    {data['estimate_name']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimate Type</span>
                                            <span className="w-100">: {data['estimate_name']}</span>
                                        </div>
                                    </div>
                                    }
                                    {data['payment_name']&&
                                       <div className="col-4 ">
                                       <div className="d-inline-flex">
                                           <span className="w-label">Mode of Payment</span>
                                           <span className="w-100">: {data['payment_name']}</span>
                                       </div>
                                   </div> 
                                    }
                                    
        
                                    {data['length_of_stay']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Length of Stay </span>
                                            <span className="w-100">: {data['length_of_stay']}</span>
                                        </div>
                                    </div>}
                                    {(data['room_stay']!==0&&data['room_stay']!==0)&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room</span>
                                            <span className="w-100">: {data['room_stay']}</span>
                                        </div>
                                    </div>}
                                    {(data['icu_stay']!==0&&data['icu_stay']!=="0.00") &&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU</span>
                                            <span className="w-100">: {data['icu_stay']} </span>
                                        </div>
                                    </div>}
                                    {data['room_opted_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Opted</span>
                                            <span className="w-100">: {data['room_opted_name']}</span>
                                        </div>
                                    </div>}
                                    {data['room_opted_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Tariff</span>
                                            <span className="w-100">: {data['room_opted_name']?data['room_opted_name']:'--'}</span>
                                        </div>
                                    </div>}
                                    {data['room_upgrade_name']&&
                                     <div className="col-4 ">
                                     <div className="d-inline-flex">
                                         <span className="w-label">Room Upgrade</span>
                                         <span className="w-100">: {data['room_upgrade_name']?data['room_upgrade_name']:'--'}</span>
                                     </div>
                                 </div>
                                    }
                                   {data['room_upgrade_reason_name']&&
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Upgrade Reason</span>
                                            <span className="w-100">: {data['room_upgrade_reason_name']?data['room_upgrade_reason_name']:'--'}</span>
                                        </div>
                                    </div>
                                   }
                                    
                                   {data['estimated_admission_date']&&
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimated Date of Admission</span>
                                            <span className="w-100">: {moment(data['estimated_admission_date']).format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>
                                   } 
                                    {data['date_of_surgery']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Date of Surgery</span>
                                                                        <span className="w-100">: {data['date_of_surgery']?moment(data['date_of_surgery']).format('DD-MM-YYYY'):'--'}</span>
                                                                    </div>
                                                                </div>}
                                    {data['procedure_name']&&<div className="col-8">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Surgery/Procedure</span>
                                            <span className="w-100">: {data['procedure_name']?data['procedure_name']:'--'}</span>
                                        </div>
                                    </div>}
                                    {/* <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Admission</span>
                                            <span className="w-100">: {data['actual_date_of_admission']}</span>
                                        </div>
                                    </div> */}
                                </div>
                                {/* estimate table */}
                                {/* <table className="table table-hover table-bordered mt-5"> */}
                                <table className={`table table-hover table-bordered ${data.estimate_type == 1 ? 'mt-2' : 'mt-5'}`}>
                                    <thead>
                                        <tr>
                                            <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                            <td className="text-capitalize">Service Name</td>
                                            <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                        </tr>
                                    </thead>
                                        <tbody>
                                        {(
                                            data["estimate_type"] === 1
                                            ? [
                                                { id: 1, label: "Consultation fees", key: "consultation_charges" },
                                                { id: 2, label: "Professional fees", key: "surgical_charges", key2: "medical_charges" },
                                                ]
                                            : [
                                                { id: 1, label: "Room Charges", key: "room_charges" },
                                                { id: 2, label: "Investigation charges", key: "room_investigation_charges" },
                                                { id: 3, label: "Service charges", key: "icu_investigation_charges" },
                                                { id: 4, label: "Pharmacy charges", key: "ip_pharmacy_charges" },
                                                { id: 5, label: "OT/ Cath Lab charges", key: "ot_cath_pharmacy" },
                                                { id: 6, label: "Procedure Charges", key: "procedure_charges" },
                                                { id: 7, label: "Other miscellaneous charges", key: "blood_bank_charges" },
                                                { id: 8, label: "Consultation fees", key: "consultation_charges" },
                                                { id: 9, label: "Professional fees", key: "surgical_charges", key2: "medical_charges" },
                                                ]
                                        )
                                            .filter(({ key, key2 }) => {
                                            if (!data["header_amount"]) return false;

                                            const amount = key2
                                                ? this.roundAmount((data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0))
                                                : this.roundAmount(data["header_amount"][key] || 0);

                                            return amount > 0;
                                            })
                                            .map(({ id, label, key, key2 }, index) => (
                                            <tr key={index + 1}>
                                                <td>{index + 1}</td>
                                                <td className="text-capitalize">{label}</td>
                                                <td className="text-uppercase">
                                                {dollarIndianLocale.format(
                                                    this.roundAmount(
                                                    key2 ? (data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0) : data["header_amount"][key] || 0
                                                    )
                                                )}
                                                </td>
                                            </tr>
                                            ))}
                                        </tbody>

                                </table>
                                {/* {(data.estimate_type == 1 || data.estimate_type==2) && <React.Fragment>
                                    {data.estimate_type ==1 && <div className="insurance py-2">
                                        <h5 className="data-label w-100">Package:</h5>
                                    </div>}
                                    {data.estimate_type ==1 && <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                                <td className="text-capitalize">Name</td>
                                                <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td className="text-uppercase">{data['package_text_name']}</td>
                                                <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(data['package_amt']))}</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td className="text-capitalize">Excludes</td>
                                                <td className="text-capitalize">
                                                  
                                                {dollarIndianLocale.format(
                                                    Object.entries(data["header_amount"] || {}).reduce((acc, [key, value]) => {
                                                    if (key !== "surgical_charges" && key !== "medical_charges" && key !== "consultation_charges") {
                                                        acc += value || 0;
                                                    }
                                                    return acc;
                                                    }, 0)
                                                )}
                                                </td>
                                                {(
                                            [
                                                { id: 1, label: "Room Charges", key: "room_charges" },
                                                { id: 2, label: "Investigation charges", key: "room_investigation_charges" },
                                                { id: 3, label: "Service charges", key: "icu_investigation_charges" },
                                                { id: 4, label: "Pharmacy charges", key: "ip_pharmacy_charges" },
                                                { id: 5, label: "OT/ Cath Lab charges", key: "ot_cath_pharmacy" },
                                                { id: 7, label: "Other miscellaneous charges", key: "blood_bank_charges" },
                                                ]
                                        )
                                            .filter(({ key, key2 }) => {
                                            if (!data["header_amount"]) return false;

                                            const amount = key2
                                                ? this.roundAmount((data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0))
                                                : this.roundAmount(data["header_amount"][key] || 0);

                                            return amount > 0;
                                            })
                                            .map(({ id, label, key, key2 }, index) => (
                                            <tr key={index + 1}>
                                                <td>{index + 1}</td>
                                                <td className="text-capitalize">{label}</td>
                                                <td className="text-uppercase">
                                                {dollarIndianLocale.format(
                                                    this.roundAmount(
                                                    key2 ? (data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0) : data["header_amount"][key] || 0
                                                    )
                                                )}
                                                </td>
                                            </tr>
                                            ))}
                                            </tr>
                                        </tbody>
                                    </table>}
                                    {data.estimate_type ==1 && <div className="clearfix pb-4 bg-white">
                                        <span className="float-left">
                                        </span>
                                        <span className="float-right">
                                        </span>
                                    </div>}
                                    {data.estimate_type ==1 &&data['additional_packages'].length>0&&<div className="insurance py-2">
                                        <h5 className="data-label w-100">Additional Package:</h5>
                                    </div>}
                                    {data.estimate_type ==1 && data['additional_packages'].length>0 && <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                                <td className="text-capitalize">Name</td>
                                                <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data['additional_packages'] && <React.Fragment>
                                                {data['additional_packages'].map((feild, key) => {
                                                    return (<React.Fragment>
                                                        <tr>
                                                            <td className="text-capitalize" style={{ 'width': '5%' }}>{key + 1}</td>
                                                            <td className="text-capitalize">{feild.package_name}</td>
                                                            <td className="text-capitalize" style={{ 'width': '20%' }}>{dollarIndianLocale.format(this.roundAmount(feild.amount))}</td>
                                                        </tr>
        
                                                        <tr>
                                                            <td></td>
                                                            <td className="text-capitalize">
                                                                {data['excludes_data'] &&
                                                                    <p>Excludes</p>
        
                                                                }
                                                                <table className="table table-hover table-bordered mb-0">
                                                                    {data['excludes_data'] && data['excludes_data'].map((excludes) => {
                                                                        if (feild.package_id == excludes.package_id) {
                                                                            return (<React.Fragment>
                                                                                <tr>
                                                                                    <td className="text-capitalize">{excludes.service_name}</td>
                                                                                </tr>
                                                                            </React.Fragment>)
                                                                        }
        
        
                                                                    })}
                                                                </table>
                                                            </td>
                                                            <td className="text-uppercase">
                                                                <p className="invisible">Excludes</p>
                                                                <table className="table table-hover table-bordered mb-0">
                                                                    {data['excludes_data'] && data['excludes_data'].map((excludes) => {
                                                                        if (feild.package_id == excludes.package_id) {
                                                                            return (<React.Fragment>
                                                                                <tr>
                                                                                    <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(excludes.amount))}</td>
                                                                                </tr>
                                                                            </React.Fragment>)
                                                                        }
        
        
                                                                    })}
        
                                                                </table>
                                                            </td>
                                                        </tr>
        
        
                                                    </React.Fragment>)
                                                })}
                                            </React.Fragment>}
                                        </tbody>
                                    </table>}
                                    {(data.estimate_type ==2 ||data.estimate_type == 1) &&data['additional_procedures'].length>0&&<div className="insurance py-2">
                                        <h5 className="data-label w-100">Additional  Procedure:</h5>
                                    </div>}
                                    {(data.estimate_type ==2 || data.estimate_type == 1) &&data['additional_procedures'].length>0&&<table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                                <td className="text-capitalize">Name</td>
                                                <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data['additional_procedures'] && <React.Fragment>
                                                {data['additional_procedures'].map((feild, key) => {
                                                    return (<React.Fragment>
                                                        <tr>
                                                            <td className="text-capitalize" style={{ 'width': '5%' }}>{key + 1}</td>
                                                            <td className="text-capitalize">{feild.procedure_name}</td>
                                                            <td className="text-capitalize" style={{ 'width': '20%' }}>{dollarIndianLocale.format(this.roundAmount(feild.amount))}</td>
                                                        </tr>
                                                    </React.Fragment>)
                                                })}
                                            </React.Fragment>}
                                        </tbody>
                                    </table>}
                                </React.Fragment>} */}
                                {/*package-estimations*/}
                                {(data.estimate_type == 1 || data.estimate_type==2) && <React.Fragment>
                                    {data.estimate_type ==1 && <div className="insurance py-2">
                                        <h5 className="data-label w-100">Package:</h5>
                                    </div>}
                                    {data.estimate_type ==1 && <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                                <td className="text-capitalize">Name</td>
                                                <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                            </tr>
                                        </thead>

                                        <tbody>
    {/* Main Procedure Row */}
    <tr>
        <td>1</td>
        <td className="text-uppercase">{data['procedure_name']}</td>
        <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(data['package_amt']))}</td>
    </tr>

    {/* Additional Packages */}
    {data['additional_packages'].map((feild, key) => (
        <React.Fragment key={key}>
            <tr>
                <td className="text-capitalize" style={{ width: '5%' }}>{key + 2}</td> 
                {/* Key + 2 ensures correct numbering after the main procedure */}
                <td className="text-capitalize">{feild.package_name}</td>
                <td className="text-capitalize" style={{ width: '20%' }}>
                    {dollarIndianLocale.format(this.roundAmount(feild.amount))}
                </td>
            </tr>
        </React.Fragment>
    ))}
</tbody>

                                    </table>}
                                    {data.estimate_type ==1 &&
                                    <span className="float-right" style={{marginRight: '145px'}}>
                                        <h4>Sub Total: {dollarIndianLocale.format(subtotal)}</h4>
                                    </span>
                                        }
                                    
                                    {data.estimate_type ==1 && <div className="clearfix pb-4 bg-white">
                                        <span className="float-left">
                                        </span>
                                        <span className="float-right">
                                        </span>
                                    </div>}
                                    
                                    {(data.estimate_type ==2 ||data.estimate_type == 1) &&data['additional_procedures'].length>0&&<div className="insurance py-2">
                                        <h5 className="data-label w-100">Additional  Procedure:</h5>
                                    </div>}
                                    {/* {JSON.stringify(data['additional_packages'])} */}
                                    {(data.estimate_type ==2 || data.estimate_type == 1) &&data['additional_procedures'].length>0&&<table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                                <td className="text-capitalize">Name</td>
                                                <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data['additional_procedures'] && <React.Fragment>
                                                {data['additional_procedures'].map((feild, key) => {
                                                    return (<React.Fragment>
                                                        <tr>
                                                            <td className="text-capitalize" style={{ 'width': '5%' }}>{key + 1}</td>
                                                            <td className="text-capitalize">{feild.procedure_name}</td>
                                                            <td className="text-capitalize" style={{ 'width': '20%' }}>{dollarIndianLocale.format(this.roundAmount(feild.amount))}</td>
                                                        </tr>
                                                    </React.Fragment>)
                                                })}
                                            </React.Fragment>}
                                        </tbody>
                                    </table>}
                                </React.Fragment>}
                                {/**/}
                                {/* estimate table */}
                                {data.estimate_type ==1 && <div className="insurance py-2">
                                        <h5 className="data-label w-100">Excludes:</h5>
                                    </div>}
                                <table className="table table-hover table-bordered mt-2">
                                    <thead>
                                        <tr>
                                            <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                            <td className="text-capitalize">Service Name</td>
                                            <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                        </tr>
                                    </thead>
                                      <tbody>
            {displayedRows.map(({ id, label, key, key2 }, index) => (
                <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td className="text-capitalize">{label}</td>
                    <td className="text-uppercase">
                        {dollarIndianLocale.format(
                            this.roundAmount(
                            key2
                                ? (data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0)
                                : data["header_amount"][key] || 0
                            )
                        )}
                    </td>
                </tr>
            ))}
        </tbody>
                                </table>
                                {data.estimate_type ==1 &&
                                <span className="float-right" style={{marginRight: '145px'}}>
                                        <h4>Sub Total: {dollarIndianLocale.format(this.roundAmount(Subtotal))}</h4>
                                </span>
                                }
                                
                            </div>
                        </div>
                    </React.Fragment>
                    {/* <div className="clearfix pb-4 bg-white px-4">
                        <span className="float-left">
                            <h4 className="mb-0">Total Estimated Amount:</h4>
                        </span>
                        <span className="float-right">
                                    <h4 className="mb-0">Rs. {formattedLowerBound} - Rs. {formattedUpperBound}</h4>

                        </span>
                    </div> */}
                    <div className="clearfix pb-4 bg-white px-4">
                    {data.estimate_type ==1 ?
                        <span className="float-left" style={{marginTop:'50px'}}>
                            <h4 className="mb-0">Total Estimated Amount:</h4>
                        </span>
                        : 
                        <span className="float-left">
                            <h4 className="mb-0">Total Estimated Amount:</h4>
                        </span>}
                        {data.estimate_type ==1 ?
                        <span className="float-right" style={{marginTop:'50px', marginLeft:'400px'}}>
                                    <h4 className="mb-0">Rs. {formattedLowerBound} - Rs. {formattedUpperBound}</h4>
                        </span>
                        :
                        <span className="float-right">
                        <h4 className="mb-0">Rs. {formattedLowerBound} - Rs. {formattedUpperBound}</h4>
                        </span>
                        }
                    </div>
                    <div className="insurance p-4 pt-0 bg-white">
                        {data.estimate_type == 1 &&
                            <>
                                <h5 className="data-label w-100">General Package Excludes:</h5>
                                <p className="one text-justify">1. Any Investigation or pharmacy item beyond the limit defined in the package.</p>
                                <p className="one text-justify">2. Food & Beverage availed by patient or attendant outside of dietician's plan.</p>
                                <p className="one text-justify">3. Any consultation or procedure done that is outside of the primary line of treatment.</p>
                                <p className="one text-justify">4. Extended stay beyond the duration of the package.</p>
                                <p className="one text-justify">5. Any service rendered during the extended stay (Investigation, Procedure, Doctor Visits).</p>
                            </>
                        }
                        <React.Fragment>
                            <p className="one text-justify">Please note that all the above costs are quoted for the stipulated / tentative length of stay. Increase in length of stay or increase in OT time due to clinical complications / comorbidities will elicit additional charges, depending on the complexity of condition / extension of treatment / period.</p>
                            <ul className="pl-3">
                                <li>For cash paying patients, an advance of 80% of the total estimated amount shall be paid at the time of admission by Cash/Card.</li>
                                <li>All cash paying patients shall maintain a positive cash balance at any time during their stay for treatment in the hospital.</li>
                                <li>Excess Amount paid (up to Rs 10,000) will be refunded to you in cash immediately at the time of final bill clearance. Refunds of amounts more than Rs. 10,000 will be transferred by NEFT within 7 business days.</li>
                                <li>As per section 269 ST, amount upto Rs 1,99,999 only will be accepted by cash. Payments greater than this amount can be done through NEFT / DD / Credit Card / Debit Card.</li>
                            </ul>
                        </React.Fragment>
                        <h5 className="data-label w-100">Declaration:</h5>
                        <p className="one text-justify">I hereby accept that all the above tariff and breakup was explained to me/us in a language I/We understand in detail. I understand that the
                            amount quoted is only an estimate and the actual charges incurred at the time of the final bill may vary. I take full responsibility of clearing
                            all dues payable to the hospital by arranging payment either by myself or through immediate family of the patient, at the time of discharge / leaving the hospital.</p>
                        <div className="clearfix pt-4">
                            <span className="float-left">
                                {/* Signature: {data["isGenerateSign"] === "yes" ? <a href={data["generatedLink"]} target="_blank">Upload Signature</a> : '____________________' }  */}
                                Signature: {this.props.digital_sig_imgpath ? <img alt="sign" src={base_url + this.props.digital_sig_imgpath} className="rounded-5 mr-3" width={100} height={80}></img> : '___________________'}
                            </span>
                            <span className="float-right">
                                Signature: ____________________
                            </span>
                            <span className="float-left">
                                Patient/Attendant Name:  {data['attendant_name'] ? data['attendant_name'] : data['patient_name']}
                            </span>
                        </div>
                        <div className="clearfix pt-4 pb-4">
                            <span className="float-left">
                                Patient/Attendant Name:  {data['attendant_name'] ? data['attendant_name'] : data['patient_name']}
                            </span>
                            <span className="float-right">
                                 Counsellor: {data['name_of_the_fc']}
                            </span>
                        </div>
                        <div className="clearfix pt-4 pb-4">
                                    <span className="float-left">
                                        This Patient is Verified with OTP <span>{` ${this.state.currentDateTime}`}
                                    </span>
                                    </span>
                        </div>
                        {/* <div className="clearfix pt-4 pb-4">
                            {this.props.new_state_value === true ?
                                    (<span className="float-left">
                                        This Patient is Verified with OTP 
                                    </span>) : null}
                        </div> */}
                    </div>
                    </>
                ):(
                    <>
                    <React.Fragment>
                        <div className="fc-patient-copy">
                            <div className="p-4 bg-white" id="myH1">
                                <div className="clearfix">
                                    <img src={`${homepage}/assets/images/units-logo/${user_data["unitid"]&&user_data["unitid"]}.png`} alt="Kims" className="float-left"></img>
                                    <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03-testing2</p>
                                </div>

                                <div>
                                    <h1 className="text-p-bold text-center text-uppercase py-4">Financial counselling</h1>
                                </div>
                                <div className="row m-0 pb-3 border">
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Counselling</span>
                                            <span className="w-100">: {moment(data['counselling_date']).format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>
                                    {data['counselling_type_name'] &&
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Counselling type</span>
                                            <span className="w-100">: {data['counselling_type_name']}</span>
                                        </div>
                                    </div>
                                    }{data['umr_no']&&
                                    <div className="col-4 ">
                                    <div className="d-inline-flex">
                                        <span className="w-label">UMR number</span>
                                        <span className="w-100">: {data['umr_no']}</span>
                                    </div>
                                </div>
                                    }
                                    {data['ip_no']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">IP number</span>
                                            <span className="w-100">: {data['ip_no']}</span>
                                        </div>
                                    </div>
                                }
                                {data['covid_status']&&
                                <div className="col-4 ">
                                    <div className="d-inline-flex">
                                        <span className="w-label">Covid Status</span>
                                        <span className="w-100">: {data['covid_status'] ?data['covid_status']:''}</span>
                                    </div>
                                </div>
                                }
                                    {data['patient_name']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Name</span>
                                            <span className="w-100">: {data['patient_name']}</span>
                                        </div>
                                        </div>
                                    }
                                {
                                    data['phone_no']&&
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Phone No.</span>
                                            <span className="w-100">: {data['phone_no']}</span>
                                        </div>
                                    </div>
                                }
                                    {data['age']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Age</span>
                                            <span className="w-100">: {data['age']}</span>
                                        </div>
                                    </div>
                                    }
                                    {data['doctor_name']&&
                                    <div className="col-4 ">
                                    <div className="d-inline-flex">
                                        <span className="w-label">Doctor Name</span>
                                        <span className="w-100">: {data['doctor_name']}</span>
                                    </div>
                                </div>   
                                    }
                                    {data['speciality_name']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Specialty</span>
                                            <span className="w-100">: {data['speciality_name']}</span>
                                        </div>
                                    </div>
                                    }
                                    {data['care_management_name']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Care Management</span>
                                            <span className="w-100">: {data['care_management_name']}</span>
                                        </div>
                                    </div>
                                    }
                                    {data['estimate_name']&&
                                        <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimate Type</span>
                                            <span className="w-100">: {data['estimate_name']}</span>
                                        </div>
                                    </div>
                                    }
                                    {data['payment_name']&&
                                    <div className="col-4 ">
                                    <div className="d-inline-flex">
                                        <span className="w-label">Mode of Payment</span>
                                        <span className="w-100">: {data['payment_name']}</span>
                                    </div>
                                </div> 
                                    }
                                    

                                    {data['length_of_stay']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Length of Stay </span>
                                            <span className="w-100">: {data['length_of_stay']}</span>
                                        </div>
                                    </div>}
                                    {(data['room_stay']!==0&&data['room_stay']!==0)&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room</span>
                                            <span className="w-100">: {data['room_stay']}</span>
                                        </div>
                                    </div>}
                                    {(data['icu_stay']!==0&&data['icu_stay']!=="0.00") &&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU</span>
                                            <span className="w-100">: {data['icu_stay']} </span>
                                        </div>
                                    </div>}
                                    {data['room_opted_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Opted</span>
                                            <span className="w-100">: {data['room_opted_name']}</span>
                                        </div>
                                    </div>}
                                    {data['room_opted_name']&&<div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Tariff</span>
                                            <span className="w-100">: {data['room_opted_name']?data['room_opted_name']:'--'}</span>
                                        </div>
                                    </div>}
                                    {data['room_upgrade_name']&&
                                    <div className="col-4 ">
                                    <div className="d-inline-flex">
                                        <span className="w-label">Room Upgrade</span>
                                        <span className="w-100">: {data['room_upgrade_name']?data['room_upgrade_name']:'--'}</span>
                                    </div>
                                </div>
                                    }
                                {data['room_upgrade_reason_name']&&
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Upgrade Reason</span>
                                            <span className="w-100">: {data['room_upgrade_reason_name']?data['room_upgrade_reason_name']:'--'}</span>
                                        </div>
                                    </div>
                                }
                                    
                                {data['estimated_admission_date']&&
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimated Date of Admission</span>
                                            <span className="w-100">: {moment(data['estimated_admission_date']).format('DD-MM-YYYY')}</span>
                                        </div>
                                    </div>
                                } 
                                    {data['date_of_surgery']&&<div className="col-4 ">
                                                                    <div className="d-inline-flex">
                                                                        <span className="w-label">Date of Surgery</span>
                                                                        <span className="w-100">: {data['date_of_surgery']?moment(data['date_of_surgery']).format('DD-MM-YYYY'):'--'}</span>
                                                                    </div>
                                                                </div>}
                                    {data['procedure_name']&&<div className="col-8">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Surgery/Procedure</span>
                                            <span className="w-100">: {data['procedure_name']?data['procedure_name']:'--'}</span>
                                        </div>
                                    </div>}
                                    {/* <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Admission</span>
                                            <span className="w-100">: {data['actual_date_of_admission']}</span>
                                        </div>
                                    </div> */}
                                </div>
                                {/*package-estimations*/}
                                {(data.estimate_type == 1 || data.estimate_type==2) && <React.Fragment>
                                    {data.estimate_type ==1 && <div className="insurance py-2">
                                        <h5 className="data-label w-100">Package:</h5>
                                    </div>}
                                    {data.estimate_type ==1 && <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                                <td className="text-capitalize">Name</td>
                                                <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                            </tr>
                                        </thead>

                                        <tbody>
    {/* Main Procedure Row */}
    <tr>
        <td>1</td>
        <td className="text-uppercase">{data['procedure_name']}</td>
        <td className="text-capitalize">{dollarIndianLocale.format(this.roundAmount(data['package_amt']))}</td>
    </tr>

    {/* Additional Packages */}
    {data['additional_packages'].map((feild, key) => (
        <React.Fragment key={key}>
            <tr>
                <td className="text-capitalize" style={{ width: '5%' }}>{key + 2}</td> 
                {/* Key + 2 ensures correct numbering after the main procedure */}
                <td className="text-capitalize">{feild.package_name}</td>
                <td className="text-capitalize" style={{ width: '20%' }}>
                    {dollarIndianLocale.format(this.roundAmount(feild.amount))}
                </td>
            </tr>
        </React.Fragment>
    ))}
</tbody>

                                    </table>}
                                    {data.estimate_type ==1 &&
                                    <span className="float-right" style={{marginRight: '145px'}}>
                                        <h4>Sub Total: {dollarIndianLocale.format(subtotal)}</h4>
                                    </span>
                                        }
                                    
                                    {data.estimate_type ==1 && <div className="clearfix pb-4 bg-white">
                                        <span className="float-left">
                                        </span>
                                        <span className="float-right">
                                        </span>
                                    </div>}
                                    
                                    {(data.estimate_type ==2 ||data.estimate_type == 1) &&data['additional_procedures'].length>0&&<div className="insurance py-2">
                                        <h5 className="data-label w-100">Additional  Procedure:</h5>
                                    </div>}
                                    {/* {JSON.stringify(data['additional_packages'])} */}
                                    {(data.estimate_type ==2 || data.estimate_type == 1) &&data['additional_procedures'].length>0&&<table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                                <td className="text-capitalize">Name</td>
                                                <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data['additional_procedures'] && <React.Fragment>
                                                {data['additional_procedures'].map((feild, key) => {
                                                    return (<React.Fragment>
                                                        <tr>
                                                            <td className="text-capitalize" style={{ 'width': '5%' }}>{key + 1}</td>
                                                            <td className="text-capitalize">{feild.procedure_name}</td>
                                                            <td className="text-capitalize" style={{ 'width': '20%' }}>{dollarIndianLocale.format(this.roundAmount(feild.amount))}</td>
                                                        </tr>
                                                    </React.Fragment>)
                                                })}
                                            </React.Fragment>}
                                        </tbody>
                                    </table>}
                                </React.Fragment>}
                                {/**/}
                                {/* estimate table */}
                                {data.estimate_type ==1 && <div className="insurance py-2">
                                        <h5 className="data-label w-100">Excludes:</h5>
                                    </div>}
                                {/* <table className="table table-hover table-bordered mt-5"> */}
                                <table className={`table table-hover table-bordered ${data.estimate_type == 1 ? 'mt-2' : 'mt-5'}`}>
                                    <thead>
                                        <tr>
                                            <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                            <td className="text-capitalize">Service Name</td>
                                            <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                        </tr>
                                    </thead>
                                      <tbody>
            {displayedRows.map(({ id, label, key, key2 }, index) => (
                <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td className="text-capitalize">{label}</td>
                    <td className="text-uppercase">
                        {dollarIndianLocale.format(
                            this.roundAmount(
                            key2
                                ? (data["header_amount"][key] || 0) + (data["header_amount"][key2] || 0)
                                : data["header_amount"][key] || 0
                            )
                        )}
                    </td>
                </tr>
            ))}
        </tbody>
                                </table>
                                {data.estimate_type ==1 &&
                                <span className="float-right" style={{marginRight: '145px'}}>
                                        <h4>Sub Total: {dollarIndianLocale.format(this.roundAmount(Subtotal))}</h4>
                                </span>
                                }
                            </div>
                        </div>
                    </React.Fragment>
                    <div className="clearfix pb-4 bg-white px-4">
                    {data.estimate_type ==1 ?
                        <span className="float-left" style={{marginTop:'50px'}}>
                            <h4 className="mb-0">Total Estimated Amount:</h4>
                        </span>
                        : 
                        <span className="float-left">
                            <h4 className="mb-0">Total Estimated Amount:</h4>
                        </span>}
                        {data.estimate_type ==1 ?
                        <span className="float-right" style={{marginTop:'50px', marginLeft:'400px'}}>
                                    <h4 className="mb-0">Rs. {formattedLowerBound} - Rs. {formattedUpperBound}</h4>
                        </span>
                        :
                        <span className="float-right">
                        <h4 className="mb-0">Rs. {formattedLowerBound} - Rs. {formattedUpperBound}</h4>
                        </span>
                        }
                    </div>
                    <div className="insurance p-4 pt-0 bg-white">
                        {data.estimate_type == 1 &&
                            <>
                                <h5 className="data-label w-100">General Package Excludes:</h5>
                                <p className="one text-justify">1. Any Investigation or pharmacy item beyond the limit defined in the package.</p>
                                <p className="one text-justify">2. Food & Beverage availed by patient or attendant outside of dietician's plan.</p>
                                <p className="one text-justify">3. Any consultation or procedure done that is outside of the primary line of treatment.</p>
                                <p className="one text-justify">4. Extended stay beyond the duration of the package.</p>
                                <p className="one text-justify">5. Any service rendered during the extended stay (Investigation, Procedure, Doctor Visits).</p>
                            </>
                        }
                        <React.Fragment>
                            <p className="one text-justify">Please note that all the above costs are quoted for the stipulated / tentative length of stay. Increase in length of stay or increase in OT time due to clinical complications / comorbidities will elicit additional charges, depending on the complexity of condition / extension of treatment / period.</p>
                            <ul className="pl-3">
                                <li>For cash paying patients, an advance of 80% of the total estimated amount shall be paid at the time of admission by Cash/Card.</li>
                                <li>All cash paying patients shall maintain a positive cash balance at any time during their stay for treatment in the hospital.</li>
                                <li>Excess Amount paid (up to Rs 10,000) will be refunded to you in cash immediately at the time of final bill clearance. Refunds of amounts more than Rs. 10,000 will be transferred by NEFT within 7 business days.</li>
                                <li>As per section 269 ST, amount upto Rs 1,99,999 only will be accepted by cash. Payments greater than this amount can be done through NEFT / DD / Credit Card / Debit Card.</li>
                            </ul>
                        </React.Fragment>
                        <h5 className="data-label w-100">Declaration:</h5>
                        <p className="one text-justify">I hereby accept that all the above tariff and breakup was explained to me/us in a language I/We understand in detail. I understand that the
                            amount quoted is only an estimate and the actual charges incurred at the time of the final bill may vary. I take full responsibility of clearing
                            all dues payable to the hospital by arranging payment either by myself or through immediate family of the patient, at the time of discharge / leaving the hospital.</p>
                        <div className="clearfix pt-4">
                            <span className="float-left">
                                {/* Signature: {data["isGenerateSign"] === "yes" ? <a href={data["generatedLink"]} target="_blank">Upload Signature</a> : '____________________' }  */}
                                Signature: {this.props.digital_sig_imgpath ? <img alt="sign" src={base_url + this.props.digital_sig_imgpath} className="rounded-5 mr-3" width={100} height={80}></img> : '___________________'}
                            </span>
                            <span className="float-right">
                                Signature: ____________________
                            </span>
                        </div>
                        <div className="clearfix pt-4 pb-4">
                            <span className="float-left">
                                Patient/Attendant Name:  {data['attendant_name'] ? data['attendant_name'] : data['patient_name']}
                            </span>
                            <span className="float-right">
                                Counsellor: {data['name_of_the_fc']}
                            </span>
                        </div>
                        {/* <div className="clearfix pt-4 pb-4">
                                    <span className="float-left">
                                        Authorized via single-use verification code <span>{` ${this.state.currentDateTime}`}
                                    </span>
                                    </span>
                        </div> */}
                        <div className="clearfix pt-4 pb-4">
                            {this.props.new_state_value === true ?
                                    (<span className="float-left">
                                        Authorized via single-use verification code <span>{` ${this.props.created_date}`}</span>
                                    </span>) : null}
                        </div>
                    </div>
                    </>
            )}
        </div>)
    }
}



export default Cash_preview;